export default __webpack_public_path__ + "static/homepage-hero-video-thumb-cb4f5f0834547d7389ee53832bee2670.jpg";